import { ReactiveControllerHost } from 'lit';
import { isEqual } from 'lodash-es';
import { PersistedReduxController } from '../../common/redux/controllers/persisted-redux-controller';
import { RootState, persistor, selectors, slices, store, userAPI } from '../redux/store';
import { ApiController } from './api-controller';
import { AuthController } from './auth-controller';

export class FavoriteController extends PersistedReduxController<RootState>  {
  authController: AuthController;
  apiController: ApiController;

  constructor(host: ReactiveControllerHost, authController: AuthController) {
    super(host, store, persistor);
    this.authController = authController;
    this.apiController = new ApiController(host);
  }
  
  get favoriteState() {
    return this.state[slices.favorites.name];
  }

  isArticleFavorite(contentId: string) {
    return selectors.favorites.getArticleState(this.favoriteState, contentId)?.isFavorite ?? false;
  }
  
  override stateChanged(state: RootState, forceUpdate: boolean): void {
    const favoriteStateChanged = !isEqual(state[slices.favorites.name], this.favoriteState);
    if (forceUpdate || favoriteStateChanged) {
      this.updateState(state);
      this.host.requestUpdate();
    }
  }

  updateFavorite(contentId: string) {
    const authData = this.authController.getAuthRequestData();
    return store.dispatch(userAPI.endpoints.updateFavorite.initiate({
      ...authData,
      content_id: contentId,
    }));
  }

  checkIsFavorite(contentId: string) {
    const authData = this.authController.getAuthRequestData();
    return store.dispatch(userAPI.endpoints.checkIsFavorite.initiate({
      ...authData,
      content_id: contentId,
    }));
  }

  updateFavoriteRequestStatus(requestId?: string) {
    return this.apiController.getRequestStatus(userAPI.endpoints.updateFavorite.name, requestId);
  }

  checkIsFavoriteRequestStatus(requestId?: string) {
    return this.apiController.getRequestStatus(userAPI.endpoints.checkIsFavorite.name, requestId);
  }
}
